import './Contact.css';
const Contact = () => {
    return ( <main>
      <section id="mission">
        <h2>Our Mission</h2>
        <p>EmpowerArt is dedicated to providing equal opportunities for growth and empowerment to non-profit organizations, orphanages, and disabled artists. We believe that every individual, regardless of their circumstances, deserves a chance to showcase their artistic talent to the world. Our mission is to break down barriers and create a platform where marginalized artists can express themselves, share their stories, and gain recognition for their exceptional creativity. By providing a space for non-profit organizations, orphanages, and disabled artists to exhibit their artwork as NFTs, we aim to amplify their voices and contribute to their personal and artistic growth.</p>
        <p>At EmpowerArt, we believe that the originality found in the art created by individuals facing challenges is a testament to their strength and resilience. By fostering an inclusive community, we seek to inspire and uplift these artists, empowering them to embrace their unique perspectives and abilities.</p>
        <p>Through our platform, we strive to create meaningful connections between artists, art enthusiasts, and supporters of non-profit organizations. By purchasing NFTs from EmpowerArt, individuals not only acquire exceptional artwork but also make a direct impact on the lives of the artists and the causes they represent. Join us on this transformative journey as we celebrate the remarkable artistic talent of marginalized individuals, proving that art transcends boundaries and has the power to create positive change.</p>
      </section>
      <section id="team">
        <h2>Our Team</h2>
        <div class="team-member">
          <img src="https://github.com/amantalreja/verbwireCommerce/blob/main/marketplace/src/pages/lgoo.png?raw=true" alt="Team Member 1"/>
          <div>
            <h3>Aman Talreja</h3>
            <p>Full Stack Developer</p>
          </div>
        </div>
        <div class="team-member">
          <img src="https://github.com/amantalreja/verbwireCommerce/blob/main/marketplace/src/pages/lgoo.png?raw=true" alt="Team Member 2"/>
          <div>
            <h3>Tanay Shah</h3>
            <p>Back-End Engineer</p>
          </div>
        </div>
        <div class="team-member">
          <img src="https://github.com/amantalreja/verbwireCommerce/blob/main/marketplace/src/pages/lgoo.png?raw=true" alt="Team Member 3"/>
          <div>
            <h3>Agastya Agarwal</h3>
            <p>Lead Designer</p>
          </div>
        </div>
      </section>
    </main>);
  };
  
  export default Contact;